import { render } from "./SiteHeadingExpandableFAQ.vue?vue&type=template&id=af7376be"
import script from "./SiteHeadingExpandableFAQ.vue?vue&type=script&lang=js"
export * from "./SiteHeadingExpandableFAQ.vue?vue&type=script&lang=js"

import "./SiteHeadingExpandableFAQ.vue?vue&type=style&index=0&id=af7376be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__